export default __webpack_public_path__ + "4d56bb21f2399db8ad480d590a49fac3.ttf";